interface ChipInsideCircleAndWirelessControlSVGProps {
  color: string;
  style: React.CSSProperties;
}

const ChipInsideCircleAndWirelessControlSVG = ({
  color,
  style,
}: ChipInsideCircleAndWirelessControlSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="51"
    height="50"
    viewBox="0 0 51 50"
    fill="none"
  >
    <g clipPath="url(#clip0_678_13620)">
      <path
        d="M36.958 17.8877C38.4346 16.9409 40.1816 16.3886 42.064 16.3886C43.9463 16.3886 45.6934 16.9409 47.1699 17.8877"
        stroke={color}
        strokeWidth="1.2624"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.3428 14.6303C36.5745 13.1988 39.212 12.3535 42.0637 12.3535C44.9154 12.3535 47.5529 13.1988 49.7846 14.6303"
        stroke={color}
        strokeWidth="1.2624"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.9785 20.6943C40.5759 20.3111 41.286 20.0857 42.0525 20.0857C42.8189 20.0857 43.529 20.3111 44.1264 20.6943"
        stroke={color}
        strokeWidth="1.2624"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.1898 34.8061C28.8535 37.5563 24.5816 39.2132 19.9153 39.2132C9.26379 39.2132 0.629883 30.5793 0.629883 19.9166C0.629883 9.25383 9.26379 0.631195 19.9153 0.631195C27.1628 0.631195 33.4748 4.62128 36.766 10.5275"
        stroke={color}
        strokeWidth="1.2624"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.065 49.3801C37.9735 49.3801 34.6484 46.055 34.6484 41.9635V31.0189C34.6484 26.9274 37.9735 23.6023 42.065 23.6023C46.1566 23.6023 49.4816 26.9274 49.4816 31.0189V41.9635C49.4816 46.055 46.1566 49.3801 42.065 49.3801Z"
        stroke={color}
        strokeWidth="1.2624"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.0067 41.862C45.0067 43.4851 43.688 44.8039 42.0649 44.8039C40.4418 44.8039 39.123 43.4851 39.123 41.862C39.123 40.239 40.4418 38.9202 42.0649 38.9202C43.688 38.9202 45.0067 40.239 45.0067 41.862Z"
        stroke={color}
        strokeWidth="1.2624"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.168 15.1713H30.5913"
        stroke={color}
        strokeWidth="1.2624"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.168 20.39H30.5913"
        stroke={color}
        strokeWidth="1.2624"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.168 25.6086H30.5913"
        stroke={color}
        strokeWidth="1.2624"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.73535 20.39H11.1587"
        stroke={color}
        strokeWidth="1.2624"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.73535 25.6086H11.1587"
        stroke={color}
        strokeWidth="1.2624"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.8877 28.8999V31.312"
        stroke={color}
        strokeWidth="1.2624"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.6582 28.8999V31.312"
        stroke={color}
        strokeWidth="1.2624"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.4385 28.8999V31.312"
        stroke={color}
        strokeWidth="1.2624"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.8877 9.46797V11.8801"
        stroke={color}
        strokeWidth="1.2624"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.6582 9.46799V11.8801"
        stroke={color}
        strokeWidth="1.2624"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5191 15.1713C18.5191 17.4932 16.6368 19.3643 14.3262 19.3643V25.6086H24.7748V15.16H18.5304L18.5191 15.1713Z"
        stroke={color}
        strokeWidth="1.2624"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_678_13620">
        <rect width="50.4058" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default ChipInsideCircleAndWirelessControlSVG;
